import { Map } from 'immutable';

import gatwick from './gatwick';


/**
 * Custom messages for Gatwick Express - Ryanair
 */

const micrositeMessages = new Map({
    'app.owner': 'Gatwick Express - Ryanair'
});

export default gatwick.merge(micrositeMessages);
